module.exports = __webpack_public_path__ + "static/img/s207.4659fc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s207.png
// module id = 549
// module chunks = 3